// ProductMenuListItem.js
import { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { BsThreeDotsVertical } from "react-icons/bs";
import canna42 from "../assets/imgPlaceholder.png";
import styles from "../styles/productMenuListItem.module.css";

const ProductMenuListItem = ({
  product,
  businessType,
  actions,
}: {
  product: any;
  businessType: string | undefined;
  actions: Actions;
}) => {
  const [imageSrc, setImageSrc] = useState<string>(product.avatarUrl || canna42);

  // Function to handle the image error
  const handleImageError = () => {
    setImageSrc(canna42); // Set the source to the default image on error
  };

  return (
    <tr className={styles.productListItem}>
      <td>
        <img
          src={imageSrc}
          alt=""
          style={{
            width: "50px",
            height: "50px",
            marginRight: "10px",
            borderRadius: 10,
            border: "1px solid #ccc",
          }}
          onError={handleImageError}
        />
        <span>{product.name}</span>
      </td>
      {businessType == "venue" && <td>{product.brand.name}</td>}
      {/* <td>{FormatInstance.renderReadableExpirationTimestamp(product.createdAt)}</td> */}
      <td>{product.category.name}</td>
      <td>{product.strain}</td>
      <td className={styles.actionsCell}>
        <Dropdown className="justify-content-center">
          {" "}
          {/* Change alignRight to align="end" */}
          <Dropdown.Toggle as={BsThreeDotsVertical} id={`dropdown-${product.id}`} />
          <Dropdown.Menu className="flex-start-end">
            {businessType === "brand" && (
              <>
                {actions.edit && ( // Ensure edit action is defined
                  <Dropdown.Item onClick={() => actions.edit && actions.edit(product)}>Edit</Dropdown.Item>
                )}
              </>
            )}
            {businessType === "venue" && actions.delete && (
              <Dropdown.Item onClick={() => actions.delete && actions.delete(product.id)}>Remove</Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </td>
    </tr>
  );
};

export default ProductMenuListItem;
